import React from "react";
import LegalLayout from "../../components/LegalLayout";

const IadePolitikasi = () => {
  return (
    <LegalLayout title="İptal ve İade Politikası">

      <h2>1. Cayma Hakkı</h2>

      <p>
        6502 Sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler
        Yönetmeliği kapsamında tüketiciler, teslim aldıkları ürünü herhangi bir
        gerekçe göstermeksizin ve cezai şart ödemeksizin 14 (ondört) gün içerisinde
        cayma hakkını kullanabilirler.
      </p>

      <br />

      <h2>2. İade Şartları</h2>

      <p>
        İade edilecek ürünün aşağıdaki şartları sağlaması gerekmektedir:
      </p>

      <ul>
        <li>Ürün kullanılmamış olmalıdır.</li>
        <li>Orijinal ambalajı zarar görmemiş olmalıdır.</li>
        <li>Fatura veya sipariş bilgileri ile birlikte gönderilmelidir.</li>
        <li>Tekrar satılabilir durumda olmalıdır.</li>
      </ul>

      <br />

      <h2>3. Cayma Hakkının Kullanılamayacağı Durumlar</h2>

      <p>
        İlgili mevzuat gereği aşağıdaki ürünlerde cayma hakkı kullanılamayabilir:
      </p>

      <ul>
        <li>Ambalajı açılmış hijyen ürünleri.</li>
        <li>Kişiye özel hazırlanan ürünler.</li>
        <li>Kullanılmış veya yeniden satışı mümkün olmayan ürünler.</li>
        <li>Yasal olarak iadesi mümkün olmayan ürün grupları.</li>
      </ul>

      <br />

      <h2>4. İade Süreci</h2>

      <p>
        İade talebiniz tarafımıza ulaştıktan sonra ürün gerekli kontrollerden
        geçirilir. İade şartlarının sağlanması halinde ürün bedeli,
        yasal süre içerisinde ödeme yaptığınız yöntem kullanılarak tarafınıza
        iade edilir.
      </p>

      <br />

      <h2>5. Kargo İşlemleri</h2>

      <p>
        İade gönderimi sırasında ürünün güvenli şekilde paketlenmesi müşterinin
        sorumluluğundadır. Ürünün taşıma sırasında zarar görmesi halinde doğabilecek
        sorumluluk göndericiye ait olabilir.
      </p>

      <br />

      <h2>6. İptal İşlemleri</h2>

      <p>
        Siparişiniz henüz kargoya verilmemişse sipariş iptal talebinde
        bulunabilirsiniz. Kargoya teslim edilen siparişlerde ise ilgili mevzuat
        kapsamında cayma hakkı hükümleri uygulanmaktadır.
      </p>

      <br />

      <h2>7. İletişim</h2>

      <p>
        İade, değişim ve sipariş iptali ile ilgili talepleriniz için aşağıdaki
        iletişim bilgilerinden bizimle iletişime geçebilirsiniz.
      </p>

      <ul>
        <li><strong>Şirket:</strong> One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ.</li>
        <li><strong>Adres:</strong> Genç Osman Mahallesi Pınar Sokak No:9 Güngören / İstanbul</li>
        <li><strong>Telefon:</strong> 0537 210 14 52</li>
        <li><strong>E-posta:</strong> goomoreinternational@gmail.com</li>
      </ul>

    </LegalLayout>
  );
};

export default IadePolitikasi;